import React from "react";
import PropTypes from "prop-types";

const ProductLogo = ({ image }) => (
  <a className="icons--site-logo">
    <img src={image} alt="MyLook" />
  </a>
);

ProductLogo.propTypes = {
  image: PropTypes.string.isRequired,
};

export default ProductLogo;
